import * as React from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";

import Button from "@replo/design-system/components/button/Button";
import IconButton from "@replo/design-system/components/button/IconButton";
import { X } from "lucide-react";

import useChatMessageLimits from "./hooks/useChatMessageLimits";

const MessageLimitWrapper = ({
  children,
}: {
  children: React.ReactElement;
}) => {
  const projectId = useCurrentProjectId();
  const { messagesRemaining, hasUnlimitedMessages } = useChatMessageLimits();

  const [isDismissed, setIsDismissed] = React.useState(false);

  const shouldShowLimitBanner = !hasUnlimitedMessages;

  const canDismissBanner = !hasUnlimitedMessages && messagesRemaining > 0;

  const showBanner =
    shouldShowLimitBanner && !(canDismissBanner && isDismissed);

  if (!showBanner) {
    return children;
  } else {
    return (
      <div
        className="flex flex-col items-center justify-center p-0.5 rounded-[10px]"
        style={{
          background:
            "linear-gradient(90deg, rgba(0, 0, 0, 0.10) -84.44%, rgba(233, 25, 108, 0.10) 100%)",
        }}
      >
        {React.cloneElement(children, {
          isMessageLimitShowing: true,
        })}
        <div className="flex justify-between items-center w-full px-2.5 py-2">
          <span className="text-base">
            {messagesRemaining <= 0
              ? "You've used all your messages"
              : `${messagesRemaining} messages remaining`}
          </span>
          <div className="flex items-center gap-1">
            <Button
              variant="tertiary"
              size="base"
              to={`/shops/${projectId}/settings/workspace/billing`}
              UNSAFE_className="text-pink-600"
            >
              Get more
            </Button>
            {canDismissBanner && (
              <IconButton
                variant="tertiary"
                size="sm"
                icon={<X className="h-4 w-4" />}
                onClick={() => setIsDismissed(true)}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
};

export default MessageLimitWrapper;
